module.exports = __webpack_public_path__ + "img/data.56eae869.png";